import axios from 'axios'
import router from '@/router';
import { Message, Loading } from 'element-ui'
import QS from 'qs'
import config from './config'
// const url = 'https://aipackage-backend.haleon.net.cn' //线上后台地址
//const url = 'https://aipackage-backend.corpnet5.com' //UAT后台地址
const url = config.apiBaseUrl
// axios默认环境
axios.defaults.baseURL = url

// SSO配置，从配置文件获取
export const ssoConfig = {
  clientId: config.sso.clientId,
  authUrl: config.sso.authUrl,
  scope: config.sso.scope,
  // 从配置文件获取重定向URL
  redirectUri: config.sso.redirectUri
}

export function getUrl(){
  return url
}

// 获取SSO认证URL，包含PKCE参数
export async function getSSOAuthUrl() {
  // 生成随机code_verifier
  const codeVerifier = pkceUtils.generateCodeVerifier();
  //console.log('生成随机code_verifier:', codeVerifier);
  // 保存code_verifier，以便后续获取token
  pkceUtils.saveCodeVerifier(codeVerifier);

  // 生成code_challenge
  const codeChallenge = await pkceUtils.generateCodeChallenge(codeVerifier);
  //console.log('生成code_challenge:', codeChallenge);
  // 返回SSO认证URL
  return `${ssoConfig.authUrl}?client_id=${ssoConfig.clientId}&redirect_uri=${encodeURIComponent(ssoConfig.redirectUri)}&response_type=code&scope=${encodeURIComponent(ssoConfig.scope || 'openid')}&code_challenge=${codeChallenge}&code_challenge_method=S256`;
}

//HttpRequest拦截器
axios.interceptors.request.use(
  async (config) => {
    // 获取token
    let result = await new Promise((resolve) => {
      //获取用户TOKEN 信息
      let data = localStorage.getItem("token") || "";
      if (data) {
        config.headers.authorization = `Bearer ${data}`
      }
      resolve(config);
    });
    return result;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// 响应拦截器 - 处理Token过期
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    if (err.response && err.response.hasOwnProperty('status') && err.response.status == 401) {
      Message.closeAll()

      // 从响应体中获取错误信息
      let errorMsg = "登录信息已过期(25分钟)，请重新登录！";
      try {
        if (err.response.data) {
          if (typeof err.response.data === 'string') {
            const errorData = JSON.parse(err.response.data);
            errorMsg = errorData.message || errorMsg;
          } else if (err.response.data.detail) {
            errorMsg = err.response.data.detail;
          } else if (err.response.data.message) {
            errorMsg = err.response.data.message;
          }
        }
      } catch (e) {
        console.error('解析错误响应失败', e);
      }

      Message.error(errorMsg)

      // 清除所有本地存储的认证信息
      localStorage.removeItem('token');
      localStorage.removeItem('sso_access_token');
      localStorage.removeItem('sso_username');
      localStorage.removeItem('token_invalid');
      sessionStorage.removeItem('pkce_code_verifier');
      localStorage.removeItem('pkce_code_verifier');
      // 注意：不清除 user_logged_out 标记，保持用户的登出状态

      // 延迟一下再跳转，让用户看到错误消息
      setTimeout(() => {
        // 跳转到根路径，让路由守卫决定是自动SSO还是跳转登录页
        window.location.href = '/';
      }, 1500);

      // 返回特殊错误以防止继续处理
      return Promise.reject({
        isAuthError: true,
        message: errorMsg
      });
    }
    return Promise.reject(err);
  }
);

/**
* 封装get方法
* @param url
* @param data
* @returns {Promise}
*/

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    const loading = Loading.service({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    axios.get(url, {
      params: params
    })
      .then(response => {
        loading.close()
        resolve(response.data)
      })
      .catch(err => {
        loading.close()
        if (err.response && err.response.status && err.response.status == 401) {
        } else {
          Message.closeAll()
          if (err.response && err.response.data && err.response.data.detail) {
            Message.error(err.response.data.detail || '请求错误');
          } else {
            Message.error(err.message || err.response.data.msg || '请求错误');
          }
        }
        reject(err)
      })
  })
}

/**
* 封装post请求
* @param url
* @param data
* @returns {Promise}
*/

export function post(url, data = {}, headers="application/json") {
  console.log(`开始POST请求: ${url}`, data);

  return new Promise((resolve, reject) => {
    const loading = Loading.service({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    // 特殊处理SSO token请求
    if (url.includes('/sso/token')) {
      //console.log('SSO token特殊处理开始');

      // 检查code和code_verifier是否存在
      if (!data.code) {
        console.error('缺少必要参数code');
      }

      if (!data.code_verifier) {
        // 如果请求体中没有code_verifier，尝试从存储中获取
        data.code_verifier = pkceUtils.getCodeVerifier();
        //console.log('自动添加code_verifier到请求中:', data.code_verifier);
      }

      // 为SSO token请求打印完整请求信息
      console.log('SSO token请求完整信息:', {
        url: url,
        baseURL: axios.defaults.baseURL,
        headers: {'Content-Type': headers},
        data: data,
        method: 'post'
      });
    }

    axios({
      method: 'post',
      url: url,
      headers:{'Content-Type': headers} , // 请求头，发送FormData格式的数据，必须是 这种请求头。
      data: data
    }).then(response => {
        loading.close()
        console.log(`POST请求成功: ${url}`, response.data);
        resolve(response.data)
      }, err => {
        loading.close()
        console.error(`POST请求失败: ${url}`, err);

        if (url.includes('/sso/token')) {
          console.error('SSO token请求失败详情:', {
            status: err.response && err.response.status,
            statusText: err.response && err.response.statusText,
            data: err.response && err.response.data,
            message: err.message
          });

          // 尝试记录请求详情
          try {
            console.error('SSO token请求配置:', err.config);
          } catch (e) {
            console.error('无法获取请求配置');
          }
        }

        if (err.response && err.response.status && err.response.status == 401) {
        } else {
          if (err.response && err.response.data && err.response.data.detail) {
            Message.error(err.response.data.detail || '请求错误');
          } else {
            Message.error(err.message || err.response.data.msg || '请求错误');
          }
        }
        reject(err)
      })
  })
}

/**
* 封装put请求
* @param url
* @param data
* @returns {Promise}
*/

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    const loading = Loading.service({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    axios.put(url, data)
      .then(response => {
        loading.close()
        resolve(response.data)
      }, err => {
        loading.close()
        if (err.response && err.response.status && err.response.status == 401) {
        } else {
          if (err.response && err.response.data && err.response.data.detail) {
            Message.error(err.response.data.detail || '请求错误');
          } else {
            Message.error(err.message || err.response.data.msg || '请求错误');
          }
        }
        reject(err)
      })
  })
}

/***
 * 封装delete请求
 *
 */
export function del(url, data = {}) {
  return new Promise((resolve, reject) => {
    const loading = Loading.service({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'

    })
    axios.delete(url, data).then(response => {
      loading.close()
      resolve(response.data)
    }, err => {
      loading.close()
      if (err.response && err.response.status && err.response.status == 401) {
      } else {
        if (err.response && err.response.data && err.response.data.detail) {
          Message.error(err.response.data.detail || '请求错误');
        } else {
          Message.error(err.message || err.response.data.msg || '请求错误');
        }
      }
      reject(err)
    })
  })
}

/**
 * 提交表单数据
 * @param {*} url
 * @param {*} data
 * @param {*} customHeaders 自定义请求头
 */
export function postForm(url, data = {}, customHeaders = {}) {
  return new Promise((resolve, reject) => {
    const loading = Loading.service({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    // 合并默认请求头和自定义请求头
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...customHeaders
    };

    // 打印完整请求信息
    console.log('发送表单请求:', {
      url: url,
      data: data,
      headers: headers
    });

    axios({
      method: 'post',
      url: url,
      headers: headers,
      data: QS.stringify(data)
    }).then(response => {
      loading.close()
      console.log(`表单请求成功: ${url}`, response.data);

      // 特殊处理登录请求的响应
      if (url.includes('/auth/login')) {
        //console.log('登录成功，token:', response.data.access_token);
      }

      resolve(response.data);
    }, err => {
      loading.close()
      console.error(`表单请求失败: ${url}`, err);

      // 特殊处理登录请求的错误
      if (url.includes('/auth/login')) {
        console.error('登录失败详情:', {
          status: err.response && err.response.status,
          statusText: err.response && err.response.statusText,
          data: err.response && err.response.data,
          message: err.message
        });
      }

      if (err.response && err.response.status && err.response.status == 401) {
      } else {
        if (err.response && err.response.data && err.response.data.detail) {
          Message.error(err.response.data.detail || '请求错误');
        } else {
          Message.error(err.message || err.response.data.msg || '请求错误');
        }
      }
      reject(err)
    })
  })
}

export function postFile(url, data = {}) {
  return new Promise((resolve, reject) => {
    const loading = Loading.service({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    axios({
      method: 'post',
      url: url,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, // 请求头，发送FormData格式的数据，必须是 这种请求头。
      data: data,
      onUploadProgress:progressEvent=>{
        const { loaded, total } = progressEvent;
        const percentCompleted = Math.round((loaded * 100) / total);
        let msg = percentCompleted >= 100?'上传已完成，等待微信响应。':`上传进度: ${percentCompleted}%`;
      }
    }).then(response => {
      loading.close()
      resolve(response.data);
    }, err => {
      loading.close()
      if (err.response && err.response.status && err.response.status == 401) {
      } else {
        if (err.response && err.response.data && err.response.data.detail) {
          Message.error(err.response.data.detail || '请求错误');
        } else {
          Message.error(err.message || err.response.data.msg || '请求错误');
        }
      }
      reject(err)
    })
  })
}

// PKCE工具函数
export const pkceUtils = {
  // 生成随机code_verifier
  generateCodeVerifier() {
    // 符合PKCE标准的字符集: A-Z, a-z, 0-9, -._~
    const allowedChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    // 使用加密安全的随机数生成器获取随机长度
    const randomBuffer = new Uint8Array(1);
    window.crypto.getRandomValues(randomBuffer);
    const length = 43 + (randomBuffer[0] % (128 - 43 + 1)); // 长度在43-128之间

    let codeVerifier = '';
    const randomValues = new Uint8Array(length);
    window.crypto.getRandomValues(randomValues);

    for (let i = 0; i < length; i++) {
      codeVerifier += allowedChars[randomValues[i] % allowedChars.length];
    }

    return codeVerifier;
  },

  // 计算code_challenge (code_verifier的SHA256哈希的BASE64URL编码)
  async generateCodeChallenge(codeVerifier) {
    try {
      // 如果没有提供code_verifier，使用存储的值或生成新的
      if (!codeVerifier) {
        codeVerifier = this.getCodeVerifier() || this.generateCodeVerifier();
      }

      // 将code_verifier转换为Uint8Array
      const encoder = new TextEncoder();
      const data = encoder.encode(codeVerifier);

      // 计算SHA-256哈希值
      const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);

      // 将哈希值转换为BASE64URL编码
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashBase64 = btoa(String.fromCharCode.apply(null, hashArray));

      // 转换为BASE64URL格式 (替换+为-, /为_, 去掉=)
      const codeChallenge = hashBase64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');

      return codeChallenge;
    } catch (error) {
      console.error('生成code_challenge失败:', error);
      // 失败时生成新的verifier并重试一次
      const fallbackVerifier = this.generateCodeVerifier();
      console.error('使用备用verifier重试:', fallbackVerifier);
      return this.retryGenerateChallenge(fallbackVerifier);
    }
  },

  // 失败时的备用挑战码生成方法
  async retryGenerateChallenge(codeVerifier) {
    try {
      const encoder = new TextEncoder();
      const data = encoder.encode(codeVerifier);
      const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashBase64 = btoa(String.fromCharCode.apply(null, hashArray));
      return hashBase64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    } catch (error) {
      console.error('备用挑战码生成也失败:', error);
      // 最后的备用方案：生成一个简单的随机字符串
      return this.generateSimpleChallenge();
    }
  },

  // 最简单的备用挑战码生成
  generateSimpleChallenge() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    let result = '';
    for (let i = 0; i < 43; i++) {
      const randomBuffer = new Uint8Array(1);
      window.crypto.getRandomValues(randomBuffer);
      result += chars.charAt(randomBuffer[0] % chars.length);
    }
    return result;
  },

  // 保存code_verifier到本地存储
  saveCodeVerifier(codeVerifier) {
    //console.log('保存code_verifier到sessionStorage:', codeVerifier);
    sessionStorage.setItem('pkce_code_verifier', codeVerifier);
    localStorage.setItem('pkce_code_verifier', codeVerifier);
  },

  // 获取保存的code_verifier
  getCodeVerifier() {
    // 优先从sessionStorage获取，如果不存在则从localStorage获取
    let codeVerifier = sessionStorage.getItem('pkce_code_verifier');

    if (!codeVerifier) {
      codeVerifier = localStorage.getItem('pkce_code_verifier');
    }

    // 如果仍然没有获取到，生成新的
    if (!codeVerifier) {
      codeVerifier = this.generateCodeVerifier();
      this.saveCodeVerifier(codeVerifier);
    }

    //console.log('获取到的code_verifier:', codeVerifier);
    return codeVerifier;
  }
};




// WEBPACK FOOTER //
// ./src/utils/http.js